import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AppWrapper = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleUnauthorized = () => {
      navigate('/unauthorized');
    };

    window.addEventListener('unauthorized', handleUnauthorized);

    return () => {
      window.removeEventListener('unauthorized', handleUnauthorized);
    };
  }, [navigate]);

  return children;
};

export default AppWrapper;
